"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1356,4077],{

/***/ 19242:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40643);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);






var GetTheAppModal = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 5056).then(__webpack_require__.bind(__webpack_require__, 95056));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(95056)
            ];
        }
    }
});
var Dropdown = function(param) {
    var items = param.items, wrapperStyle = param.wrapperStyle, itemId = param.itemId, icon = param.icon, _withHoverEffect = param.withHoverEffect, withHoverEffect = _withHoverEffect === void 0 ? true : _withHoverEffect, backgroundColor = param.backgroundColor, menuStyle = param.menuStyle, dropdownMode = param.dropdownMode, dropdownButtonStyle = param.dropdownButtonStyle;
    var colorMode = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useColorMode)().colorMode;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(""), getTheAppModalTitle = ref[0], setGetTheAppModalTitle = ref[1];
    var isMobileView = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useIsMobileView)();
    var ref1 = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useDisclosure)(), isGetTheAppModalOpen = ref1.isOpen, onGetTheAppModalOpen = ref1.onOpen, onGetTheAppModalClose = ref1.onClose;
    var renderDropdownButton = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.IconButton, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            "data-testid": "insight-dropdown-menu-button",
            _focus: undefined,
            backgroundColor: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color.transparent,
            "aria-label": "Options",
            px: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.XS.rem,
            _hover: undefined,
            _active: undefined,
            onClick: function() {
                return;
            }
        }, dropdownButtonStyle), {
            children: icon !== null && icon !== void 0 ? icon : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.ThreeDotsVerticalSvg, {
                boxSize: "24px",
                color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].text
            })
        }));
    };
    var _icon;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Dropdown, {
        wrapperButtonStyle: {
            _hover: withHoverEffect ? {
                backgroundColor: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].surface,
                borderRadius: "full",
                cursor: "pointer"
            } : undefined,
            _active: {
                backgroundColor: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].surface,
                borderRadius: "full",
                cursor: "pointer"
            },
            _focus: undefined,
            _pressed: undefined
        },
        dropdownButtonRenderer: renderDropdownButton,
        menuStyle: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            background: backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].background,
            minWidth: "14rem"
        }, menuStyle),
        wrapperStyle: wrapperStyle,
        dropdownMode: dropdownMode,
        children: function(onClose) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                border: "none",
                padding: "8px 0",
                borderRadius: "10px",
                shadow: undefined,
                _hover: undefined,
                zIndex: "10",
                maxW: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(270),
                flexDir: "column",
                children: [
                    items.map(function(item, index) {
                        return item && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Button, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                            backgroundColor: backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].background,
                            _hover: {
                                bg: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].top
                            }
                        }, deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.typography.primaryTextFonts.medium.regular), {
                            width: "100%",
                            color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].textSecondary,
                            borderRadius: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.S.rem,
                            onClick: function(e) {
                                e.stopPropagation();
                                if (isMobileView && item.getTheAppTitle) {
                                    setGetTheAppModalTitle(item.getTheAppTitle);
                                    onGetTheAppModalOpen();
                                } else {
                                    item.callback();
                                }
                                onClose();
                            },
                            height: "fit-content",
                            minHeight: "2.5rem",
                            id: itemId ? "".concat(itemId, "-button") : undefined,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                                width: "100%",
                                alignItems: "center",
                                id: itemId ? "".concat(itemId, "-content-wrapper") : undefined,
                                children: [
                                    (_icon = item.icon) !== null && _icon !== void 0 ? _icon : null,
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Text, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                                        paddingLeft: "20px",
                                        w: "fit-content",
                                        color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].textSecondary,
                                        "data-testid": "idea-dropdown-option",
                                        id: itemId ? "".concat(itemId, "-title") : undefined
                                    }, item.titleStyling), {
                                        children: item.title
                                    }))
                                ]
                            })
                        }), index);
                    }),
                    isGetTheAppModalOpen && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(GetTheAppModal, {
                        isOpen: isGetTheAppModalOpen,
                        onClose: onGetTheAppModalClose,
                        title: getTheAppModalTitle
                    })
                ]
            });
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Dropdown);


/***/ }),

/***/ 51356:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_IdeaCardActionBar; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/deepstash-ui/esm/index.js + 78 modules
var esm = __webpack_require__(40643);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./src/components/dropdown/Dropdown.tsx
var Dropdown = __webpack_require__(19242);
// EXTERNAL MODULE: ./src/components/modals/report-modal/ReportModal.tsx + 3 modules
var ReportModal = __webpack_require__(34077);
// EXTERNAL MODULE: ./src/providers/hooks/useAuth.ts + 1 modules
var useAuth = __webpack_require__(79139);
// EXTERNAL MODULE: ./src/services/analytics/index.ts
var analytics = __webpack_require__(62687);
// EXTERNAL MODULE: ./src/utils/constants.tsx
var constants = __webpack_require__(14531);
// EXTERNAL MODULE: ./src/utils/global.ts
var global = __webpack_require__(63069);
// EXTERNAL MODULE: ./src/utils/strings/toastStrings.ts
var toastStrings = __webpack_require__(12481);
;// CONCATENATED MODULE: ./src/components/idea-card/components/IdeaCardDropdown.tsx











var IdeaCardDropdown = function(param) {
    var idea = param.idea, source = param.source;
    var id = idea.id, content = idea.content;
    var colorMode = (0,esm.useColorMode)().colorMode;
    var toast = (0,esm.useToast)();
    //Dispatch is an empty functions if we are not on the article page
    //DeleteIdea will make the delete api call even without the Source Provider.
    //So don't call at the same time with deleteIdea from activity
    //Report modal
    var ref = (0,esm.useDisclosure)(), isOpen = ref.isOpen, onOpen = ref.onOpen, onClose = ref.onClose;
    var isLoggedIn = (0,useAuth/* default */.Z)().isLoggedIn;
    //This idea is the main idea on an idea page.
    var onCopyLink = function() {
        if (id !== -1) {
            analytics/* Analytics.logEvent */.c.logEvent({
                eventName: analytics/* Events.sharing.shareContent */.z.sharing.shareContent,
                properties: {
                    id: id,
                    contentType: "idea",
                    type: "link"
                },
                platforms: [
                    "amplitude"
                ]
            });
        }
        if (source) {
            navigator.clipboard.writeText("https://deepstash.com/article/".concat(source.id, "/").concat((0,global/* slugify */.lV)(source.title), "#idea_").concat(idea.id)).then(function() {
                toast({
                    title: toastStrings/* default.linkCopied */.Z.linkCopied,
                    description: "The link to the idea has been successfully copied.",
                    status: "success",
                    duration: constants/* TOAST_TIME */.du,
                    isClosable: true
                });
            });
        }
    };
    var onCopyContent = function() {
        if (id !== -1) {
            analytics/* Analytics.logEvent */.c.logEvent({
                eventName: analytics/* Events.sharing.shareContent */.z.sharing.shareContent,
                properties: {
                    id: id,
                    contentType: "idea",
                    type: "text"
                },
                platforms: [
                    "amplitude"
                ]
            });
        }
        navigator.clipboard.writeText((0,global/* handleHtmlToText */.Pu)(content)).then(function() {
            toast({
                title: toastStrings/* default.contentCopied */.Z.contentCopied,
                description: "The content has been successfully copied.",
                status: "success",
                duration: constants/* TOAST_TIME */.du,
                isClosable: true
            });
        });
    };
    var items = [
        {
            title: "Copy text",
            callback: onCopyContent,
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.CopySvg, {
                color: esm.color[colorMode].textSecondary
            })
        },
        {
            title: "Copy link",
            callback: onCopyLink,
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.UrlSvg, {
                color: esm.color[colorMode].textSecondary
            })
        }, 
    ];
    //Add the report button if SI
    var itemsPublicIdea = isLoggedIn ? (0,_to_consumable_array/* default */.Z)(items).concat([
        {
            title: "Report",
            callback: onOpen,
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.FlagReportSvg, {
                color: esm.color.failure["default"]
            }),
            titleStyling: {
                color: esm.color.failure["default"]
            }
        }, 
    ]) : items;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* default */.Z, {
                items: itemsPublicIdea
            }),
            isOpen && source && /*#__PURE__*/ (0,jsx_runtime.jsx)(ReportModal["default"], {
                isOpen: isOpen,
                onClose: onClose,
                id: id,
                resourceOwner: source.userData.id,
                type: "idea"
            })
        ]
    });
};
/* harmony default export */ var components_IdeaCardDropdown = (IdeaCardDropdown);

// EXTERNAL MODULE: ./src/providers/hooks/useActivity.ts
var useActivity = __webpack_require__(8565);
// EXTERNAL MODULE: ./src/providers/hooks/useProfile.ts
var useProfile = __webpack_require__(2334);
// EXTERNAL MODULE: ./src/utils/collection.utils.ts
var collection_utils = __webpack_require__(85295);
// EXTERNAL MODULE: ./src/providers/hooks/useNsiActivity.ts
var useNsiActivity = __webpack_require__(7964);
// EXTERNAL MODULE: ./src/utils/StringUtils.tsx
var StringUtils = __webpack_require__(94030);
;// CONCATENATED MODULE: ./src/components/idea-card/components/IdeaReadsLabel.tsx











var IdeaReadsLabel = function(param) {
    var idea = param.idea;
    var ref, ref1, ref2;
    var colorMode = (0,esm.useColorMode)().colorMode;
    var isLoggedIn = (0,useAuth/* default */.Z)().isLoggedIn;
    var ref3 = (0,useActivity/* default */.Z)(), activity = ref3.activity, activityDispatch = ref3.activityDispatch;
    var ref4 = (0,useNsiActivity/* default */.Z)(), nsiActivityDispatch = ref4.nsiActivityDispatch, nsiReads = ref4.reads, getCanUseNsiActivity = ref4.getCanUseNsiActivity;
    var toast = (0,esm.useToast)();
    var id = idea.id, totalReads = idea.totalReads;
    var profile = (0,useProfile/* default */.Z)().profile;
    var isIdeaReadInCurrSession = (activity === null || activity === void 0 ? void 0 : (ref = activity.sessionReads) === null || ref === void 0 ? void 0 : ref.has(id)) || nsiReads.sessionReads.has(id);
    var ref5;
    var readsDoneByCurrentUser = isLoggedIn ? (ref5 = activity === null || activity === void 0 ? void 0 : (ref1 = activity.reads) === null || ref1 === void 0 ? void 0 : ref1[id]) !== null && ref5 !== void 0 ? ref5 : 0 : nsiReads.sessionReads.has(id) ? 1 : 0;
    var onReadsLabelClick = function(ev) {
        ev.preventDefault();
        ev.stopPropagation();
        if (isIdeaReadInCurrSession) {
            toast({
                id: "idea-already-read",
                title: "Idea read",
                description: "You read this idea recently.",
                duration: constants/* TOAST_TIME */.du,
                isClosable: true,
                customBackgroundColor: esm.color[colorMode].top,
                customTextColor: esm.color[colorMode].text,
                customIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.CheckSvg, {
                    color: esm.color.success,
                    width: esm.spacing.XL.rem,
                    height: esm.spacing.XL.rem,
                    marginRight: esm.spacing.S.rem
                })
            });
        } else {
            if (isLoggedIn) {
                var ref;
                activityDispatch({
                    type: "increment-read",
                    payload: {
                        ideaId: id,
                        readingGoal: (ref = profile === null || profile === void 0 ? void 0 : profile.dailyReadingGoal) !== null && ref !== void 0 ? ref : 0,
                        collectionId: (0,collection_utils/* getCollectionIdOnSourcePage */.rX)()
                    }
                });
            } else {
                nsiActivityDispatch({
                    type: "read-idea",
                    payload: {
                        ideaId: id
                    }
                });
            }
        }
    };
    return isLoggedIn || getCanUseNsiActivity() ? /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
        px: esm.spacing.XS.rem,
        onClick: onReadsLabelClick,
        align: "center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.PrimaryText, {
            size: "s",
            color: esm.color[colorMode].textSecondary,
            children: [
                (0,global/* numberFormatter */.V2)(totalReads + readsDoneByCurrentUser),
                ((activity === null || activity === void 0 ? void 0 : (ref2 = activity.reads) === null || ref2 === void 0 ? void 0 : ref2[id]) || nsiReads.sessionReads.has(id)) && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.PrimaryText, {
                    display: "inline",
                    size: "s",
                    color: esm.color[colorMode].primary.default,
                    px: esm.spacing.XXS.rem,
                    children: "(+".concat(readsDoneByCurrentUser, ")")
                }),
                " ",
                (0,StringUtils/* getSingularOrPlural */.Lo)(totalReads + readsDoneByCurrentUser, "read", "reads")
            ]
        })
    }) : null;
};
/* harmony default export */ var components_IdeaReadsLabel = (IdeaReadsLabel);

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/types/index.ts
var types = __webpack_require__(3620);
// EXTERNAL MODULE: ./src/providers/hooks/useNsi.ts
var useNsi = __webpack_require__(9182);
// EXTERNAL MODULE: ./src/components/modals/users-modal/UsersModal.tsx
var UsersModal = __webpack_require__(7494);
// EXTERNAL MODULE: ./src/providers/activity/ActivityReducerUtils.ts
var ActivityReducerUtils = __webpack_require__(13198);
;// CONCATENATED MODULE: ./src/components/idea-card/components/stash-button/IdeaStashButton.tsx













var StashOptionsMenu = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 44680));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(44680)
            ];
        }
    }
});
var IdeaStashButton = function(param) {
    var idea = param.idea, onIdeaStashed = param.onIdeaStashed, onIdeaUnstashed = param.onIdeaUnstashed, source = param.source;
    var ref;
    var isLoggedIn = (0,useAuth/* default */.Z)().isLoggedIn;
    var colorMode = (0,esm.useColorMode)().colorMode;
    var ref1 = (0,useActivity/* default */.Z)(), activity = ref1.activity, toggleIdeaStash = ref1.toggleIdeaStash;
    var ideaId = idea.id, totalSaves = idea.totalSaves;
    var ref2 = (0,useNsiActivity/* default */.Z)(), nsiStash = ref2.stash, getCanUseNsiActivity = ref2.getCanUseNsiActivity;
    var ref3 = (0,esm.useDisclosure)(), isUsersModalOpen = ref3.isOpen, onUsersModalOpen = ref3.onOpen, onUsersModalClose = ref3.onClose;
    var currentSelectedStashId = (0,react.useMemo)(function() {
        var ref, ref1;
        return !isLoggedIn && getCanUseNsiActivity() && nsiStash.stashedIdeas[ideaId] ? ActivityReducerUtils/* NSI_STASH_ID */._g : (ref1 = activity === null || activity === void 0 ? void 0 : (ref = activity.stashedIdeas) === null || ref === void 0 ? void 0 : ref.find(function(x) {
            return x[0] === ideaId;
        })) === null || ref1 === void 0 ? void 0 : ref1[1];
    }, [
        activity === null || activity === void 0 ? void 0 : activity.stashedIdeas,
        ideaId,
        nsiStash.stashedIdeas
    ]);
    var ref4;
    //If this is an idea the current user publisehd without a stash, it will appear in the stashed idea id, but won't have a stash associated
    var isStashed = !isLoggedIn && !!currentSelectedStashId || ((ref4 = activity === null || activity === void 0 ? void 0 : (ref = activity.stashedIdeasIds) === null || ref === void 0 ? void 0 : ref.includes(ideaId)) !== null && ref4 !== void 0 ? ref4 : false);
    var nsiDispatch = (0,useNsi/* default */.Z)().nsiDispatch;
    var onStashClick = function(stashId) {
        if (!source) {
            return;
        }
        if ((!isLoggedIn || !activity) && !getCanUseNsiActivity()) {
            nsiDispatch({
                type: "openAuth",
                payload: {
                    type: "sign-in"
                }
            });
            return;
        }
        analytics/* Analytics.logEvent */.c.logEvent({
            eventName: analytics/* Events.organising.saveIdea */.z.organising.saveIdea,
            properties: {
                ideaId: ideaId,
                sourceId: source.id,
                destination: "stash"
            },
            platforms: [
                "amplitude"
            ]
        });
        toggleIdeaStash({
            ideaId: ideaId,
            sourceId: source.id,
            stashId: stashId,
            onSuccess: function() {
                onIdeaStashed === null || onIdeaStashed === void 0 ? void 0 : onIdeaStashed();
            }
        });
    };
    var onUnstashClick = function() {
        if (!source) {
            return;
        }
        // If the user is not logged in we want to show the auth modal when he tries to stash an idea
        // However, if we are on a page that allows NSI activity tracking, don't show the modal
        if ((!isLoggedIn || !activity) && !getCanUseNsiActivity()) {
            nsiDispatch({
                type: "openAuth",
                payload: {
                    type: "sign-in"
                }
            });
            return;
        }
        analytics/* Analytics.logEvent */.c.logEvent({
            eventName: analytics/* Events.organising.removeIdea */.z.organising.removeIdea,
            properties: {
                ideaId: ideaId
            },
            platforms: [
                "amplitude"
            ]
        });
        toggleIdeaStash({
            ideaId: ideaId,
            sourceId: source.id,
            onSuccess: function() {
                onIdeaUnstashed === null || onIdeaUnstashed === void 0 ? void 0 : onIdeaUnstashed();
            }
        });
    };
    var formattedNumStashes = (0,react.useMemo)(function() {
        return (0,global/* numberFormatter */.V2)(// Add one save for the NSI stash
        totalSaves + (!isLoggedIn && nsiStash.stashedIdeas[ideaId] ? 1 : 0));
    }, [
        totalSaves,
        nsiStash.stashedIdeas
    ]);
    var onStashLabelClick = function(ev) {
        ev.stopPropagation();
        ev.preventDefault();
        if (ideaId === -1) return;
        analytics/* Analytics.logEvent */.c.logEvent({
            eventName: analytics/* Events.consumption.contentTap */.z.consumption.contentTap,
            properties: {
                id: ideaId,
                type: "idea",
                element: "save-count",
                location: "idea-card"
            },
            platforms: [
                "amplitude"
            ]
        });
        onUsersModalOpen();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
        align: "center",
        children: [
            source && /*#__PURE__*/ (0,jsx_runtime.jsx)(StashOptionsMenu, {
                isStashed: isStashed,
                selectedStashId: currentSelectedStashId,
                onStash: onStashClick,
                onUnstash: onUnstashClick,
                _hover: {
                    backgroundColor: esm.color[colorMode].surface
                },
                id: "idea-stash-button-".concat(ideaId),
                ideaId: ideaId,
                source: source
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
                px: esm.spacing.XS.rem,
                onClick: onStashLabelClick,
                _hover: {
                    textDecoration: "underline"
                },
                align: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.PrimaryText, {
                    size: "m",
                    color: esm.color[colorMode].text,
                    children: formattedNumStashes
                })
            }),
            isUsersModalOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(UsersModal/* default */.Z, {
                onClose: onUsersModalClose,
                isOpen: isUsersModalOpen,
                id: ideaId,
                usecase: types/* UsersModalType.SAVES */.X3.SAVES
            })
        ]
    });
};
/* harmony default export */ var stash_button_IdeaStashButton = (IdeaStashButton);

;// CONCATENATED MODULE: ./src/components/idea-card/components/IdeaCardActionBar.tsx






// const IdeaLikeButton = dynamic(() => import('./IdeaLikeButton'));
var IdeaCardActionBar = function(param) {
    var source = param.source, idea = param.idea, onIdeaStashed = param.onIdeaStashed, onIdeaUntashed = param.onIdeaUntashed;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
        w: "100%",
        paddingTop: esm.spacing.S.rem,
        justifyContent: "space-between",
        alignItems: "center",
        onClick: function(e) {
            return e.stopPropagation();
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
                align: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stash_button_IdeaStashButton, {
                    idea: idea,
                    source: source,
                    onIdeaStashed: onIdeaStashed,
                    onIdeaUnstashed: onIdeaUntashed
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_IdeaReadsLabel, {
                        idea: idea
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_IdeaCardDropdown, {
                        source: source,
                        idea: idea
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_IdeaCardActionBar = (/*#__PURE__*/react.memo(IdeaCardActionBar));


/***/ }),

/***/ 34077:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ReportModal": function() { return /* binding */ ReportModal; },
  "default": function() { return /* binding */ report_modal_ReportModal; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/deepstash-ui/esm/index.js + 78 modules
var esm = __webpack_require__(40643);
// EXTERNAL MODULE: ./src/api/Insight.ts
var Insight = __webpack_require__(32209);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/modals/report-modal/ReportModalConfirmation.tsx



var ReportModalConfirmation = function() {
    var colorMode = (0,esm.useColorMode)().colorMode;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                fontSize: "1.75rem",
                lineHeight: "2.375rem",
                fontWeight: "bold",
                color: esm.color[colorMode].text,
                align: "center",
                pt: esm.spacing.L.rem,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.CheckSvg, {
                        color: esm.color.success,
                        boxSize: "1.5rem"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, {
                        children: "Report sent."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                px: "0px",
                pb: esm.spacing.XXL.rem,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, {
                    color: esm.color[colorMode].textSecondary,
                    align: "center",
                    children: "Thank you for reporting! Our team will look into it as quickly as possible and take all the necessary actions."
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/modals/report-modal/ReportModalInitialBody.tsx



var ReportModalInitialBody = function(param) {
    var options = param.options, setSelectedOption = param.setSelectedOption, handleReport = param.handleReport;
    var colorMode = (0,esm.useColorMode)().colorMode;
    var handleSelectOption = function(option) {
        return function() {
            if (option !== "Something else") {
                handleReport(option);
            }
            setSelectedOption(option);
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
                fontSize: "1.75rem",
                lineHeight: "2.375rem",
                fontWeight: "bold",
                color: esm.color[colorMode].text,
                align: "center",
                py: "unset",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, {
                    children: "Report"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Box, {
                px: "0px",
                pb: "25px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, {
                        align: "center",
                        mb: esm.spacing.XXL.rem,
                        mt: "unset",
                        children: "Why are you reporting this?"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.UnorderedList, {
                        listStyleType: "none",
                        mt: esm.spacing.L.rem,
                        children: options.map(function(option, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.ListItem, {
                                borderTop: "1px solid ".concat(esm.color.light.underground),
                                paddingY: esm.spacing.XS.rem,
                                paddingX: esm.spacing.XXS.rem,
                                cursor: "pointer",
                                _hover: {
                                    backgroundColor: esm.color[colorMode].background
                                },
                                onClick: handleSelectOption(option),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, {
                                            children: option
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.CaretRightSvg, {})
                                    ]
                                })
                            }, index);
                        })
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./src/utils/constants.tsx
var constants = __webpack_require__(14531);
;// CONCATENATED MODULE: ./src/components/modals/report-modal/ReportModalText.tsx






var ReportModalText = function(param) {
    var handleReport = param.handleReport;
    var colorMode = (0,esm.useColorMode)().colorMode;
    var toast = (0,esm.useToast)();
    var ref = (0,react.useState)(""), localValue = ref[0], setLocalValue = ref[1];
    var onSendReportPress = function() {
        if (localValue.trim() !== "") {
            handleReport(localValue);
        } else {
            toast({
                title: "Invalid message!",
                description: "Message cannot be empty.",
                status: "error",
                duration: constants/* TOAST_TIME */.du,
                isClosable: true
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
                fontSize: "1.75rem",
                lineHeight: "2.375rem",
                fontWeight: "bold",
                color: esm.color[colorMode].text,
                align: "center",
                py: "unset",
                justifyContent: "center",
                pt: "1rem",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, {
                    children: "Report"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Box, {
                px: "0px",
                pb: "10px",
                mt: esm.spacing.S.rem,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        color: esm.color[colorMode].textSecondary
                    }, esm.typography.primaryTextFonts.medium.semiBold), {
                        my: esm.spacing.XS.rem,
                        mt: 0,
                        children: "Something else"
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.TextArea, (0,_object_spread/* default */.Z)({
                        placeholder: "Tell us what's wrong with this...",
                        textColor: esm.color[colorMode].textSecondary,
                        borderRadius: 16,
                        _focus: {
                            border: "2px solid ".concat(esm.color.light.primary["default"])
                        },
                        backgroundColor: esm.color[colorMode].top,
                        color: esm.color[colorMode].text,
                        value: localValue,
                        onChange: function(e) {
                            return setLocalValue(e.target.value);
                        },
                        minHeight: 128,
                        w: "100%",
                        py: "0.75rem",
                        px: "1rem",
                        boxSizing: "border-box"
                    }, esm.typography.primaryTextFonts.medium.regular))
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                m: "unset",
                p: "unset",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.SecondaryButton, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    colorMode: colorMode,
                    title: "Send report",
                    onClick: onSendReportPress,
                    w: "100%"
                }, esm.typography.primaryTextFonts.medium.bold), {
                    borderRadius: 16,
                    fontSize: esm.spacing.toRem(18)
                }))
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/services/analytics/index.ts
var analytics = __webpack_require__(62687);
;// CONCATENATED MODULE: ./src/components/modals/report-modal/ReportModal.tsx












var options = [
    "It's offensive or inappropriate",
    "Inaccurate or misleading information",
    "Nudity or sexual activity",
    "Hate speech",
    "Something else", 
];
var ReportModal = function(param) {
    var isOpen = param.isOpen, onClose = param.onClose, id = param.id, resourceOwner = param.resourceOwner, type = param.type;
    var colorMode = (0,esm.useColorMode)().colorMode;
    var isMobileView = (0,esm.useIsMobileView)();
    var ref = (0,react.useState)(), selectedOption = ref[0], setSelectedOption = ref[1];
    var ref1 = (0,react.useState)(false), isDone = ref1[0], setIsDone = ref1[1];
    var handleReport = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(reportType) {
            var error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            (0,Insight/* reportContentOrUser */.Jd)({
                                type: type,
                                id: id,
                                resource_owner: resourceOwner,
                                reason: reportType
                            })
                        ];
                    case 1:
                        _state.sent();
                        analytics/* Analytics.logEvent */.c.logEvent({
                            eventName: analytics/* Events.social.reportContentOrUser */.z.social.reportContentOrUser,
                            properties: {
                                type: type,
                                reason: reportType
                            },
                            platforms: [
                                "amplitude"
                            ]
                        });
                        setIsDone(true);
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        setIsDone(false);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleReport(reportType) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleClose = function() {
        if (!isDone) {
            setSelectedOption(undefined);
        }
        onClose();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Modal, {
        isOpen: isOpen,
        onClose: handleClose,
        backgroundColor: esm.color[colorMode].surface,
        borderRadius: "20px",
        p: "16px",
        minWidth: isMobileView ? "300px" : "475px",
        width: isMobileView ? "calc(100% - 1rem)" : "40%",
        modalBodyProps: {
            px: "0.25rem"
        },
        color: esm.color[colorMode].text,
        children: !selectedOption ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ReportModalInitialBody, {
            options: options,
            setSelectedOption: setSelectedOption,
            handleReport: handleReport
        }) : selectedOption === "Something else" && !isDone ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ReportModalText, {
            handleReport: handleReport
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ReportModalConfirmation, {})
    });
};
/* harmony default export */ var report_modal_ReportModal = (ReportModal);


/***/ }),

/***/ 7494:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40643);
/* harmony import */ var hooks_useInfiniteScroll__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4428);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var theme_Scrollbar_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(48373);
/* harmony import */ var theme_Scrollbar_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(theme_Scrollbar_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var utils_normalizers_profile__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7269);
/* harmony import */ var src_components_user_UserFollowRow__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27903);
/* harmony import */ var src_services_analytics__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62687);








var UsersModal = function(param) {
    var isOpen = param.isOpen, onClose = param.onClose, id = param.id, usecase = param.usecase, dataProp = param.data, titleProp = param.title, updateFollowingNum = param.updateFollowingNum;
    var colorMode = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useColorMode)().colorMode;
    var isMobileView = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useIsMobileView)();
    var USER_API_QUERY_SIZE = 20;
    var target = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    var initialUrl = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        switch(usecase){
            case "saves":
                return "/user/saved_block/".concat(id, "/");
            case "followers":
                return "/user/".concat(id, "/followers/");
            case "following":
                return "/user/".concat(id, "/following/");
            // [Like functionality]
            // case 'likes':
            //   return `/user/liked_block/${id}/`;
            case "top-stashers":
                return "/hashtag/top_stashers/".concat(id, "/");
            default:
                return "";
        }
    }, [
        usecase,
        id
    ]);
    var ref = (0,hooks_useInfiniteScroll__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        firstPageUrl: initialUrl,
        queryKey: [
            "userModal",
            usecase,
            id
        ],
        getKey: function(_index, previousPageData) {
            var ref;
            if (!isOpen) return undefined;
            // reached the end
            if (previousPageData && previousPageData.objects.length === 0) return undefined;
            return (ref = previousPageData.meta.next) === null || ref === void 0 ? void 0 : ref.replace("/api/v2", "");
        },
        target: target
    }), data = ref.data, isFetching = ref.isFetching, isFirstLoading = ref.isFirstLoading;
    var modalTitle = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        if (titleProp) {
            return titleProp;
        }
        switch(usecase){
            case "saves":
                return "People who stashed this idea";
            case "followers":
                return "Followers";
            case "following":
                return "Following";
            // [Like functionality]
            // case 'likes':
            //   return 'People who liked this idea';
            default:
                return "";
        }
    }, [
        usecase,
        titleProp
    ]);
    var users = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        return data.length === 0 ? dataProp !== null && dataProp !== void 0 ? dataProp : [] : data.map(function(users) {
            return users.objects.map(utils_normalizers_profile__WEBPACK_IMPORTED_MODULE_6__/* .normalizeUserData */ .Te);
        }).flat();
    }, [
        data,
        dataProp
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        // Log the loaded page whenever a new page is loaded.
        // Nothing will be logged for those with no followers.
        if (users.length != 0) src_services_analytics__WEBPACK_IMPORTED_MODULE_5__/* .Analytics.logEvent */ .c.logEvent({
            eventName: src_services_analytics__WEBPACK_IMPORTED_MODULE_5__/* .Events.modals.usersModal */ .z.modals.usersModal,
            properties: {
                type: usecase !== null && usecase !== void 0 ? usecase : "saves",
                pageCount: Math.ceil(users.length / USER_API_QUERY_SIZE)
            },
            platforms: [
                "amplitude"
            ]
        });
    }, [
        users.length
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Modal, {
        isOpen: isOpen,
        onClose: onClose,
        borderRadius: "15px",
        backgroundColor: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].surface,
        height: "60vh",
        maxWidth: "28rem",
        width: {
            base: "calc(100% - 1rem)",
            lg: "40vw"
        },
        modalBodyProps: {
            className: colorMode === "light" ? (theme_Scrollbar_module_scss__WEBPACK_IMPORTED_MODULE_7___default().scrollVerticalLightSurface) : (theme_Scrollbar_module_scss__WEBPACK_IMPORTED_MODULE_7___default().scrollVerticalDarkSurface)
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].text,
                width: "95%",
                borderRadius: "15px 15px 0 0",
                top: 0,
                left: 0,
                paddingLeft: "2rem",
                paddingTop: "2rem",
                justifyContent: "flex-start",
                position: "absolute",
                zIndex: 1,
                backgroundColor: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].surface,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.PrimaryHeading, {
                    size: "h2",
                    textSize: isMobileView ? "s" : "m",
                    type: "bold",
                    children: modalTitle
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Box, {
                mt: "3rem",
                children: [
                    users.map(function(user) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_user_UserFollowRow__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            user: user,
                            onUserClick: onClose,
                            onFollowSuccess: updateFollowingNum,
                            usecase: usecase
                        }, "users-modal-user-row-".concat(user.id));
                    }),
                    !isFirstLoading && isFetching && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                        justifyContent: "center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Spinner, {
                            color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].textSecondary
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Box, {
                        h: "50px",
                        ref: target
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (UsersModal);


/***/ })

}]);